import {
  alpha,
  Box,
  Button,
  CircularProgress,
  Divider,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface FormActionsProps {
  onCancel: () => void;
  submitLabel?: string;
  submitting?: boolean;
  disabled?: boolean;
  submitType?: "button" | "submit";
  onSubmit?: () => void;
}

const FormActions: React.FC<FormActionsProps> = ({
  onCancel,
  submitLabel,
  submitting = false,
  disabled = false,
  submitType = "submit",
  onSubmit,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ mt: 3 }}>
      <Divider sx={{ mb: 2.5 }} />
      <Box display="flex" gap={1.5}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          sx={{
            flex: 1,
            py: 1.2,
            color: "text.secondary",
            borderColor: "divider",
            "&:hover": {
              borderColor: "text.disabled",
              bgcolor: alpha(theme.palette.text.primary, 0.03),
              boxShadow: "none",
            },
          }}
        >
          {t("buttons.cancel")}
        </Button>
        <Button
          type={submitType}
          variant="contained"
          disabled={submitting || disabled}
          onClick={onSubmit}
          sx={{
            flex: 2,
            py: 1.2,
          }}
        >
          {submitting ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            submitLabel || t("buttons.save")
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default FormActions;
